export default {
  POSTHOG_API_KEY: `${process.env.VUE_APP_POSTHOG_API_KEY}`,
  POSTHOG_API_HOST: `${process.env.VUE_APP_POSTHOG_API_HOST}`,
  API_BASE_URL: `${process.env.VUE_APP_API_HOST}`,
  OSAGO_WEB_HOST: `${process.env.VUE_APP_OSAGO_WEB_HOST}`,
  YM_SITEKEY: parseInt(`${process.env.VUE_APP_YM_SITEKEY}`, 10),
}
